import React, { useState, useEffect } from 'react';
import {
  Row, Tabs, Tab, DropdownButton, Dropdown, Container,
} from 'react-bootstrap';
import CardsKum from '../../../components/Card';
import { Content } from './style';
import axiosInstance from '../../../components/axios/axiosApi';

const DaftarInformasi = () => {
  const [infokum, setInfokum] = useState([]);
  const [state, setState] = useState('today');
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    setInfokum([]);
    switch (state) {
      case 'before':
        switch (filter) {
          case 'seminar':
            axiosInstance.get('api/kuliah_umum/filter/?date=before&tag=seminar')
              .then((info) => {
                setInfokum(
                  info.data,
                );
              });
            break;

          case 'kuliah_umum':
            axiosInstance.get('api/kuliah_umum/filter/?date=before&tag=kuliah_umum')
              .then((info) => {
                setInfokum(
                  info.data,
                );
              });
            break;

          default:
            axiosInstance.get('api/kuliah_umum/filter/?date=before')
              .then((info) => {
                setInfokum(
                  info.data,
                );
              });
        }
        break;
      case 'after':
        switch (filter) {
          case 'seminar':
            axiosInstance.get('api/kuliah_umum/filter/?date=after&tag=seminar')
              .then((info) => {
                setInfokum(
                  info.data,
                );
              });
            break;

          case 'kuliah_umum':
            axiosInstance.get('api/kuliah_umum/filter/?date=after&tag=kuliah_umum')
              .then((info) => {
                setInfokum(
                  info.data,
                );
              });
            break;

          default:
            axiosInstance.get('api/kuliah_umum/filter/?date=after')
              .then((info) => {
                setInfokum(
                  info.data,
                );
              });
        }
        break;
      default:
        switch (filter) {
          case 'seminar':
            axiosInstance.get('api/kuliah_umum/filter/?date=today&tag=seminar')
              .then((info) => {
                setInfokum(
                  info.data,
                );
              });
            break;

          case 'kuliah_umum':
            axiosInstance.get('api/kuliah_umum/filter/?date=today&tag=kuliah_umum')
              .then((info) => {
                setInfokum(
                  info.data,
                );
              });
            break;

          default:
            axiosInstance.get('api/kuliah_umum/filter/?date=today')
              .then((info) => {
                setInfokum(
                  info.data,
                );
              });
        }
    }
  }, [state, filter]);

  return (
    <Content>
      <Container className="container-list">
        <Row className="rowatas">
          <div className="tabs-filter">
            <Tabs
              className="tabkum"
              id="controlled-tab"
              data-testid="date"
              activeState={state}
              onSelect={(k) => setState(k)}
            >
              <Tab eventKey="today" title="Today's Event" />
              <Tab eventKey="before" title="Past Event" />
              <Tab className="upcoming" eventKey="after" title="Upcoming Event" />
            </Tabs>
          </div>
          <DropdownButton className="dropdownkum" title="Filter" activeState={state} onSelect={(k) => setFilter(k)}>
            <Dropdown.Item eventKey="all">All</Dropdown.Item>
            <Dropdown.Item eventKey="kuliah_umum">Kuliah Umum</Dropdown.Item>
            <Dropdown.Item eventKey="seminar">Seminar Ilmiah</Dropdown.Item>
          </DropdownButton>
        </Row>
        <Row className="cardkum">
          {infokum.map((post) => (
            <CardsKum
              key={post.id}
              gambar={post.image_url}
              nama={post.nama_kegiatan}
              tanggal={post.tanggal}
              jam={post.pukul}
              link={post.id}
            />
          ))}
        </Row>
      </Container>
    </Content>
  );
};

export default DaftarInformasi;
